var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#EBEAED",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.14286 0 0 7.14286 0 16C0 24.8571 7.14286 32 16 32C24.8571 32 32 24.8571 32 16C32 7.14286 24.8571 0 16 0ZM16 1.28571C21.5 1.28571 26.2857 4.28571 28.7857 8.78572H11.3571V15.3571H1.35714C1.64286 7.57143 8.07143 1.28571 16 1.28571ZM16 30.7143C8.07143 30.7143 1.64286 24.4286 1.28571 16.6429H16.0714L13.9286 18.7143L14.8571 19.6429L18.5714 16L14.8571 12.3571L13.9286 13.2857L16.0714 15.3571H12.5714V10.0714H29.4286C30.2143 11.8571 30.7143 13.8571 30.7143 16C30.7143 18.1429 30.2857 20.1429 29.4286 21.9286H12.6429V17.7857H11.3571V23.2143H28.8571C28.5714 23.7857 28.2143 24.2857 27.8571 24.7857H11.4286V26.0714H26.7857C24 28.9286 20.2143 30.7143 16 30.7143Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayCard);
export default __webpack_public_path__ + "static/media/pay-card.37c95481.svg";
export { ForwardRef as ReactComponent };